export default __webpack_public_path__ + "assets/caa243d00532af8c65d5ad388bc8f049.png";